export const FETCH_PRACTITIONERS_REQUEST = 'location/FETCH_PRACTITIONERS_REQUEST';
export const FETCH_PRACTITIONERS_SUCCESS = 'location/FETCH_PRACTITIONERS_SUCCESS';
export const FETCH_PRACTITIONERS_FAILURE = 'location/FETCH_PRACTITIONERS_FAILURE';
